import React from "react";

const UserContacts = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon" {...props}>
    <path
      d="M2.5 1.66675H15.8374C16.7557 1.66675 17.5 2.41526 17.5 3.32575V16.6744C17.5 17.5907 16.7562 18.3334 15.8374 18.3334H2.5V1.66675ZM5.83333 3.33341H4.16667V16.6667H5.83333V3.33341ZM7.5 16.6667H15.8333V3.33341H7.5V16.6667ZM9.16667 13.3334C9.16667 11.9527 10.2859 10.8334 11.6667 10.8334C13.0474 10.8334 14.1667 11.9527 14.1667 13.3334H9.16667ZM11.6667 10.0001C10.7462 10.0001 10 9.25391 10 8.33341C10 7.41294 10.7462 6.66675 11.6667 6.66675C12.5872 6.66675 13.3333 7.41294 13.3333 8.33341C13.3333 9.25391 12.5872 10.0001 11.6667 10.0001ZM18.3333 5.00008H20V8.33341H18.3333V5.00008ZM18.3333 10.0001H20V13.3334H18.3333V10.0001Z"
      fill="currentColor"
    />
  </svg>
);
export default UserContacts;
